import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { KeyRound, LogIn } from "lucide-react";
import Avatar from "../Avatar";
import Button from "../Button";
import { useResetPasswordModal } from "../../../features/TraxxionProfile/hooks/useResetPasswordModal";
import { useImpersonate } from "../../../features/People/api";
import { getPrimaryActiveResource, renderUserName } from "../../../utils/helpers/user";
import { renderSettingsResourceLabel } from "../../../utils/helpers/settings";

function Header({ user }: any) {
    const { t } = useTranslation();
    const { login, loading: loginLoading, userBeingImpersonated } = useImpersonate();
    const { open: openResetPasswordModal, modal: resetPasswordModal } = useResetPasswordModal(user);

    const job = useMemo(() => {
        return getPrimaryActiveResource(user?.jobs || []);
    }, [user?.jobs]);

    const isDisabled = useMemo(() => {
        const disabledStatuses = ["terminated", "leaveOfAbsence", "unverified", "suspended", "retired", "inactive"];
        return (
            disabledStatuses.includes(user?.status) ||
            loginLoading || (userBeingImpersonated !== null && userBeingImpersonated !== user?.id)
        );
    }, [user?.status, user?.id, loginLoading, userBeingImpersonated]);

    return (
        <div className="tw-border tw-w-full tw-p-5 tw-mb-2 tw-rounded-xl tw-flex tw-items-center tw-justify-between tw-flex-wrap tw-gap-2">
            <div className="tw-flex tw-items-center tw-gap-4">
                <Avatar size="lg" user={user} />
                <div className="tw-flex tw-flex-col">
                    <h1 className="tw-font-semibold">{renderUserName(user)}</h1>
                    <p className="tw-text-sm tw-text-neutral-700">{renderSettingsResourceLabel(job)}</p>
                </div>
            </div>

            <div className="tw-flex tw-items-center tw-gap-2">
                <Button
                    // size="xs"
                    variant="ghost"
                    className="tw-text-primary tw-bg-primary/5"
                    onClick={() => login(user?.id)}
                    disabled={isDisabled}
                    icon={<LogIn />}
                >
                    {t("log-in")}
                </Button>
                <Button
                    // size="xs"
                    variant="ghost"
                    className="tw-text-orange-500 hover:tw-text-orange-500 tw-bg-orange-100/60 hover:tw-bg-orange-100/50"
                    disabled={loginLoading}
                    onClick={openResetPasswordModal}
                    icon={<KeyRound />}
                >
                    {t("reset-password")}
                </Button>
            </div>

            {resetPasswordModal}
        </div>
    );
}

export default Header;
